import React from 'react';
import { Modal } from '../shared/Modal';
import { CheckCircle } from 'lucide-react';
interface ServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  service: {
    title: string;
    description: string;
    features: string[];
    benefits: string[];
  };
}
export function ServiceModal({
  isOpen,
  onClose,
  service
}: ServiceModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title={service.title} data-id="element-171">
      <div className="space-y-6" data-id="element-172">
        <p className="text-stone text-lg leading-relaxed" data-id="element-173">
          {service.description}
        </p>

        <div data-id="element-174">
          <h3 className="text-xl font-bold text-charcoal mb-4" data-id="element-175">Key Features</h3>
          <ul className="space-y-3" data-id="element-176">
            {service.features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-177">
                <CheckCircle size={20} className="text-gold flex-shrink-0 mt-1" data-id="element-178" />
                <span className="text-stone" data-id="element-179">{feature}</span>
              </li>)}
          </ul>
        </div>

        <div data-id="element-180">
          <h3 className="text-xl font-bold text-charcoal mb-4" data-id="element-181">Benefits</h3>
          <ul className="space-y-3" data-id="element-182">
            {service.benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-183">
                <CheckCircle size={20} className="text-gold flex-shrink-0 mt-1" data-id="element-184" />
                <span className="text-stone" data-id="element-185">{benefit}</span>
              </li>)}
          </ul>
        </div>

        <div className="pt-4 border-t border-stone/20" data-id="element-186">
          <button onClick={onClose} className="w-full bg-gold text-white py-3 rounded-lg font-semibold hover:bg-gold/90 transition-colors" data-id="element-187">
            Request a Quote
          </button>
        </div>
      </div>
    </Modal>;
}